import { ListChart, ListChartProps } from '../../../../renderers/list-chart/list-chart.component';
import { PUDO_TRANSACTION_VOLUME_BY_RECEIVER_LIST_CHART_DEFINITION } from './pudo-transaction-volume-by-receiver-list-chart.definition';
import { PUDO_TRANSACTION_VOLUME_BY_RECEIVER_LIST_CHART_MOCK_DATA } from './pudo-transaction-volume-by-receiver-list-chart.mock';

export const PudoTransactionVolumeByReceiverListChart = (props: ListChartProps) => <ListChart {...props} />;

PudoTransactionVolumeByReceiverListChart.definition = PUDO_TRANSACTION_VOLUME_BY_RECEIVER_LIST_CHART_DEFINITION;
PudoTransactionVolumeByReceiverListChart.mockData = PUDO_TRANSACTION_VOLUME_BY_RECEIVER_LIST_CHART_MOCK_DATA;
